import { library } from "@fortawesome/fontawesome-svg-core"
import { faChartLine, faChartPie } from "@fortawesome/free-solid-svg-icons"

library.add(faChartLine, faChartPie)
